import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = ({ parentId, houseId }) => ['services-get', parentId, houseId];

const getServices = async ({ parentId, houseId }) => {
  return await request.get(
    `/Request/services?parentIds=${parentId}&houseId=${houseId}`,
    null,
    'При получении списка причин произошла ошибка'
  );
};

const useServicesQuery = (param, options) =>
  useQuery(key(param), () => getServices(param), options);

export default useServicesQuery;
